let isAutoOpenRequested = false

// Asks the accounts page to open the bank transactions demo as soon as it is shown
export const requestBankDemoAutoOpen = (): void => {
  isAutoOpenRequested = true
}

// Returns whether an auto-open request was pending, clearing it so it only fires once
export const consumeBankDemoAutoOpenRequest = (): boolean => {
  const wasRequested = isAutoOpenRequested
  isAutoOpenRequested = false

  return wasRequested
}
